'use strict';

import angular from 'angular';

import uiRouter from '@uirouter/angularjs';

import routing from './account.routes';
import login from './login';

export default angular.module('leptonApp.account', [uiRouter, login])
  .config(routing)
  .name;



// WEBPACK FOOTER //
// ./public/dev/app/account/index.js